import { sortBy } from 'lodash';
import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

export default {
  get(options) {
    // http://localhost:3000/api_publica/v1/gestion_economica/modalidades?visible=true
    return cifraClient.get('/api_publica/v1/gestion_economica/modalidades', options);
  },
  /**
   * Devuelve un array que dentro contiene la estructura necesaria para que select2
   * muestre las modalidades agrupadas dentro de su servicio correspondiente
   */
  getAgrupadasSelect2(options) {
    return new Promise((resolve, reject) => {
      this.get(options).then((result) => {
        const cache = {};
        result.data.forEach((modalidad) => {
          let servicio = cache[modalidad.servicio.id];
          if (!servicio) {
            servicio = {
              id: modalidad.servicio.id,
              text: modalidad.servicio.nombre,
              children: [],
            };
            cache[modalidad.servicio.id] = servicio;
          }
          servicio.children.push({
            id: modalidad.id,
            text: modalidad.nombre,
            ...modalidad,
          });
        });
        // Ordenamos servicios
        // FIXME: No está case insensitive ni tiene en cuenta tildes. hacer como en utils/usuarios
        let data = Object.values(cache);
        data = sortBy(data, 'text');
        // Dentro de cada servicio ordenamos sus modalidades
        data.forEach((servicio) => {
          servicio.children = sortBy(servicio.children, 'text');
        });
        resolve(data);
      }).catch((error) => reject(error));
    });
  },
};